import React from 'react';
import { isMobile } from '@pascal/pascal-core';

export function NumberItem({
  self,
  isHot,
  right,
  number,
  bottom,
  isCold,
  center,
  isSelected,
  winNumbers,
  selectedData,
}) {
  return (
    // ToDo:for selected number add 'selected-group' class
    <div
      className={`
        keno-numbers-item 
        ${isCold ? 'cold-state' : ''}
        ${isSelected ? 'selected' : ''}
        ${selectedData.includes(number) ? 'selected-group' : ''}
        ${isHot ? 'hot-state' : ''}
        ${winNumbers.includes(number) ? 'active' : ''}
        `}
      data-type={self}
    >
      <p className='keno-numbers-txt' data-type={self}>
        <span className='keno-number-inner-txt' data-type={self}>
          {number}
        </span>
      </p>
      {!isMobile() && right ? <div className='center-right hover-block' data-type={right} /> : null}
      {!isMobile() && bottom ? (
        <div className='bottom-right hover-block' data-type={bottom} />
      ) : null}
      {!isMobile() && center ? (
        <div className='bottom-center hover-block' data-type={center} />
      ) : null}
    </div>
  );
}
